import React from 'react';

import IconShippingTruck from '../../../../components-v2/icons/sources/shipping-truck';
import IconMarket from '../../../../components-v2/icons/sources/market';
import IconCarrot from '../../../../components-v2/icons/sources/carrot';
import IconCalendar from '../../../../components-v2/icons/sources/calendar';
import IconOffer from '../../../../components-v2/icons/sources/offer';
import IconDelivery from '../../../../components-v2/icons/sources/delivery';
import IconFull from '../../../../components-v2/icons/sources/full';
import IconMeliPlus from '../../../../components-v2/icons/sources/meli-plus.delete';
import IconInternationalLogo from '../../../../components-v2/icons/sources/international-logo';
import IconReviews from '../../../../components-v2/icons/sources/star-full';
import IconReviewsHalfStar from '../../../../components-v2/icons/sources/star-half';
import IconPayment from '../../../../components-v2/icons/sources/payment';
import IconCoupon from '../../../../components-v2/icons/sources/icon-coupons';

const IconBuilder = {
  cart_fs_icon: <IconShippingTruck />,
  cart_supermarketcart_icon: <IconMarket />,
  cart_fresh_icon: <IconCarrot />,
  cart_calendar_icon: <IconCalendar />,
  cart_offers_icon: <IconOffer />,
  delivered_by_meli_icon: <IconDelivery />,
  fulfillment_cart: <IconFull />,
  meli_plus_icon: <IconMeliPlus />,
  international_logo_icon: <IconInternationalLogo className="pill-option-icon-international-logo" />,
  poly_star_fill_icon: <IconReviews className="pill-option-icon-star-full" />,
  poly_star_half_icon: <IconReviewsHalfStar className="pill-option-icon-star-full" />,
  payment_icon: <IconPayment />,
  ic_coupon: <IconCoupon />,
};

export default IconBuilder;
